function CourseReviewCard({
  category,
  hikePercentage,
  userImage,
  userName,
  userPost,
  userBio,
  pre,
  post,
  linkedIn
}) {
  return (
    <div className="whatpeoplesaybox position-relative">
      <div className="card-sub-title position-absolute d-flex justify-content-center align-items-center text-center">
        <p>{category}</p>
      </div>
      <div className="hikebox">
        <span>
          {hikePercentage}%{" "}
          <i className="fa fa-line-chart" aria-hidden="true"></i>
        </span>
      </div>


      <div className="d-flex">
        <div className="col-3 profile-pic position-relative">
          <img
            className="profile-pic"
            loading="lazy"
            src={userImage}
            alt=""
          />
          <a
            className="linkdin-img position-absolute"
            target="_blank"
            href={linkedIn}
            rel="noreferrer"
          >
            <img
              width="28"
              height="28"
              src="assets/images/linkdin.png"
              alt=""
            />
          </a>
        </div>
        <div className="col-9 align-items-center pl-4">
          <h3>{userName}</h3>
          <h4 style={{ fontSize: 14 }}>{userPost}</h4>
        </div>
      </div>
      <p className="description border-left pl-3 py-2">{userBio}</p>
      {pre && post ? (
        <div className="whatpeoplesaybox-mid">
          <div className="prelogic">
            <div className="scalerbox scalerbox_left">
              <label htmlFor="">Pre Logicmojo</label> {pre}
            </div>
          </div>
          <div className="arrow">
            <div className="scalerbox-arrow">
              <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
            </div>
          </div>
          <div className="postlogic">
            <div className="scalerbox">
              <label htmlFor="">Post Logicmojo</label>
              <img
                loading="lazy"
                style={{ height: "auto" }}
                src={post}
                alt=""
              />
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}
export default CourseReviewCard;
